import React from "react";
import {Form, InputNumber, Tooltip} from "antd";
import {MAX_ITEMS_RULE_NAME} from "@reside/forms/dist/validator/validators/maxItemsValidator";

import {
  useFocusedNode,
  useSetFocusedNodePropertyValue,
} from "../../model/editor";
import {getRuleValue, isFieldArray, updateRules} from "../../utils";
import {FormControlSourceNode} from "../../model/schemaTypes";

export const getMaxItemsRuleValue = getRuleValue(MAX_ITEMS_RULE_NAME, parseInt);

export const getInitialMaxItemsFormValue = (node: FormControlSourceNode) => {
  try {
    return {
      [MAX_ITEMS_RULE_NAME]: getMaxItemsRuleValue(node.rules),
    };
  } catch {
    return {};
  }
};

export const MaxItemsAttribute = () => {
  const node = useFocusedNode();
  const setValidationRules = useSetFocusedNodePropertyValue("rules");

  if (!node) {
    return null;
  }

  return isFieldArray(node) ? (
    <Form.Item
      name={MAX_ITEMS_RULE_NAME}
      label={
        <Tooltip title="Maximum number of items the field array will allow to enter.">
          <span>Max items</span>
        </Tooltip>
      }
      rules={[{type: "number", min: 0}]}
    >
      <InputNumber
        min={0}
        onChange={value =>
          setValidationRules(
            updateRules(
              [...(node.rules ?? [])],
              `${value ?? ""}`,
              MAX_ITEMS_RULE_NAME,
            ),
          )
        }
      />
    </Form.Item>
  ) : (
    <>
      Attribute "${MAX_ITEMS_RULE_NAME}" can be used only with FIELD_ARRAY type
    </>
  );
};
